const css_classes = {
    backdrop: 'ovolo-modal__backdrop',
    modal: 'ovolo-modal__modal',
    modal_close_btn: 'ovolo-modal__modal__close-btn',
    modal_header: 'ovolo-modal__modal__header',
    modal_body: 'ovolo-modal__modal__body',
};

export interface ModalOptionDefault {
    should_create?: boolean,
    css_classes?: string,
    create_callback?: any,
    open_callback?: any,
    close_callback?: any,
}

const option_default: ModalOptionDefault = {
    should_create: true,
    css_classes: '',
    create_callback: null,
    open_callback: null,
    close_callback: null,
};

export class Modal {

    backdrop_el: JQuery = null;
    modal_el: JQuery = null;
    option: ModalOptionDefault = option_default;

    constructor(option: ModalOptionDefault = option_default) {
        this.option = option;
    }

    create(option_param = {}) {
        const option = $.extend(this.option, option_param)
        const body_el = $('body');
        $(`.${css_classes.backdrop}, .${css_classes.modal}`).remove();

        let backdrop_html = `<div class="${css_classes.backdrop}"></div>`;
        this.backdrop_el = $(backdrop_html);
        this.backdrop_el.on('click', () => {
            this.close();
        });
        body_el.append(this.backdrop_el)

        let modal_html = `<div class="${css_classes.modal}">
            <div class="${css_classes.modal_close_btn}"></div>
            <div class="${css_classes.modal_header}"></div>
            <div class="${css_classes.modal_body}"></div>
        </div>`
        this.modal_el = $(modal_html);
        if (option.css_classes !== '') {
            this.modal_el.addClass(option.css_classes);
        }

        this.modal_el.find(`.${css_classes.modal_close_btn}`).on('click', () => {
            this.close();
        });

        if (typeof option.create_callback === 'function') {
            option.create_callback(this.modal_el, this.backdrop_el);
        }

        body_el.append(this.modal_el)
    }

    open(option_param={}) {
        const option = $.extend(this.option, option_param)
        if (
            option.should_create
            || this.backdrop_el === null || this.modal_el === null
            || !this.modal_el.length || !this.backdrop_el.length
        ) {
            this.create();
        }

        setTimeout(() => {
            this.backdrop_el.addClass(`is-ready`);
            this.modal_el.addClass(`is-ready`);

            setTimeout(() => {
                this.backdrop_el.addClass(`is-open`);
                this.modal_el.addClass(`is-open`);
            }, 50);

        }, 100);
    }

    close(option_param={}) {
        const option = $.extend(this.option, option_param)
        setTimeout(() => {
            $(`.${css_classes.backdrop}, .${css_classes.modal}`).removeClass(`is-open`);

            if (typeof option.close_callback === 'function') {
                option.close_callback(this.modal_el, this.backdrop_el);
            }

            setTimeout(() => {
                $(`.${css_classes.backdrop}, .${css_classes.modal}`).removeClass(`is-ready`);
            }, 250);

        }, 50);
    }

}